import React, {useEffect, useState} from 'react'
import '../css/admin.css'
import {BlockchainService} from "../blockchain-service";
import {getCampaignContract, Phase} from "../utils";

import Background from '../components/assets/img/bg.jpg'
import {useWeb3React} from "@web3-react/core";
import {PhenomCampaign} from "../contracts/PhenomCampaign";
import {BigNumber, ContractTransaction, ethers} from "ethers";
import {AdminTable} from "./admin-table";


export function AdminPage() {
    const [phase, setPhase] = useState<Phase>(Phase.SEED)
    const { active, account, library, connector, activate, setError, deactivate } = useWeb3React()
    const [campaignContract, setCampaignContract] = useState<PhenomCampaign>()
    const [availableTokensByCurrentPhase, setAvailableTokensByCurrentPhase] = useState('')
    const [priceByCurrentPhase, setPriceByCurrentPhase] = useState(0)
    const [token, setToken] = useState<'PHETA'|'BUSD'>('PHETA')
    const [amountRaw, setAmountRaw] = useState('')
    const [amount, setAmount] = useState(0)
    const [address, setAddress] = useState('')
    const [phetaAmount, setPhetaAmount] = useState(0)
    const [registration, setRegistration] = useState(false)
    const [currentTgeDate, setCurrentTgeDate] = useState(0)
    const [newTgeDate, setNewTgeDate] = useState<number>()
    // const [preTgePurchasesLeft, setPreTgePurchasesLeft] = useState<number>()
    const [tgeDateUpdating, setTgeDateUpdating] = useState(false)

    useEffect(() => {
        (async () => {
            const contract = await getCampaignContract(library)
            setCampaignContract(contract)
            const vestingStartTime = await contract.vestingStartTime();
            setCurrentTgeDate(vestingStartTime.toNumber())
            // setPreTgePurchasesLeft(200 - (await contract.preTgePurchasesCount()).toNumber())
            // const data = await contract.getInvestedAmount()
            // setInvested(data.toNumber())
            // let vestingTime = (await campaignContract.vestingStartTime()).toNumber()
            // setTgeTime(new Date(vestingTime * 1000))
            // setPublicRoundActive(vestingTime > 0 && vestingTime < Date.now() / 1000)
            // setPublicRoundActive(await campaignContract.publicRoundActive())
        })().then()
    }, [])

    const onTokenChanged = async (e) => {
        setToken(e.target.value)
    }

    const onPhaseChanged = async (e) => {
        setPhase(Number(e.target.value))
    }

    // const startVesting = async () => {
    //     setTgeDateUpdating(true)
    //     try {
    //         const tx = await campaignContract.setTgeTime(newTgeDate)
    //         await tx.wait()
    //         setCurrentTgeDate((await campaignContract.vestingStartTime()).toNumber())
    //     } catch (e) {
    //         console.warn(e)
    //         if (e && e.error && e.error.message) {
    //             alert(e.error.message)
    //         }
    //     }
    //     setTgeDateUpdating(false)
    // }

    const onAmountChange = (e) => {
        let amount = e.target.value
        setAmountRaw(amount)

        setAmount(0)

        if (amount) {
            try {
                amount = Number(amount.replace(",", "."))
                setAmount(amount)
            } catch (e) {
                console.log(e)
            }
        }
    }

    const register = async () => {
        setRegistration(true)
        try {
            let tx: ContractTransaction
            if (token === 'BUSD') {
                tx = await campaignContract.registerUsdPurchase(phase, address, amount * 100)
            } else {
                const amountEth = ethers.utils.parseEther(amount.toString())
                tx = await campaignContract.registerPurchase(phase, address, amountEth)
            }
            console.log(tx.hash)
            const recept = await tx.wait()
            setAmount(0)
            setAmountRaw('')
            setAddress('')
        } catch (e) {
            console.log(e)
            if (e && e.error && e.error.message) {
                alert(e.error.message)
            }
        }
        setRegistration(false)
    }

    useEffect(() => {(async () => {
        if (campaignContract) {
            const vestingStartTime = await campaignContract.vestingStartTime()
            let availableAmount = await campaignContract.getWithdrawableAmountByPhase(phase)
            if (vestingStartTime.toNumber() === 0) {
                // vesting not started yet
                const preTgeTotal = await campaignContract.preTgePurchaseTotals(phase)
                availableAmount = availableAmount.sub(preTgeTotal)
            }
            setAvailableTokensByCurrentPhase(ethers.utils.formatEther(availableAmount).replace(/\B(?=(\d{3})+(?!\d))/g, " "))
            setPriceByCurrentPhase((await campaignContract.priceByPhase(phase)).toNumber() / 1000)
        }
    })().then()}, [campaignContract, phase, registration])

    useEffect(() => {
        if (token === 'BUSD') {
            setPhetaAmount(amount / priceByCurrentPhase)
        } else {
            setPhetaAmount(0)
        }
    }, [token, amount, priceByCurrentPhase])

    useEffect(() => {
        if (!priceByCurrentPhase && token === 'BUSD' ) {
            setToken('PHETA')
        }
    }, [priceByCurrentPhase, token])

    return (
        <section className={'ap-container'} style={{backgroundImage: `url(${Background})`}}>
            <div className={'ap-content'}>
                <div className={'ap-content-container'}>
                    <AdminTable updateHandler={registration}/>
                    <div className={'ap-form'}>
                        <h2 className={'ap-form-title'}>Register New investment</h2>
                        <div className={'inputs-one'}>
                            <p className={'inputs-one-input-one-desc'}>Choose round</p>
                            <div className={'input-one'}>
                                <div className={'select-one'}>
                                    <select onChange={onPhaseChanged}>
                                        <option value={Phase.SEED}>Seed Round</option>
                                        <option value={Phase.PRIVATE}>Private Round</option>
                                        <option value={Phase.COMMUNITY_SALE}>Community Sale</option>
                                        {/*<option value={Phase.COMMUNITY_SALE_1}>Community Sale 1</option>*/}
                                        {/*<option value={Phase.COMMUNITY_SALE_2}>Community Sale 2</option>*/}
                                        {/*<option value={Phase.COMMUNITY_SALE_3}>Community Sale 3</option>*/}
                                        <option value={Phase.FUNDING_TEAM}>Funding Team</option>
                                        <option value={Phase.ADVISORS}>Advisors</option>
                                        <option value={Phase.MARKETING}>Marketing</option>
                                        <option value={Phase.DEVELOPMENT}>Development</option>
                                    </select>
                                </div>
                                <div className={'select-one-texts'}>
                                    <p className={'select-one-texts-one'}>available: <span>{availableTokensByCurrentPhase}</span> pheta tokens</p>
                                    { !!priceByCurrentPhase && <p className={'select-one-texts-two'}>1 pheta = {priceByCurrentPhase} usd</p> }
                                </div>
                            </div>
                        </div>
                        <div className={'form-two'}>
                            <div className="form-two-input-one">
                                <p className={'form-two-input-one-desc inputs-one-input-one-desc'}>Address</p>
                                <input value={address} onChange={(e) => setAddress(e.target.value)}
                                       type="text" className={'form-two-input-one-input'} placeholder={'Address'} required/>
                            </div>
                            <div className="form-two-input-two">
                                <p className={'form-two-input-two-desc inputs-one-input-one-desc'}>Amount</p>
                                <input value={amountRaw} onChange={onAmountChange}
                                       type="text" className={'form-two-input-two-input'} placeholder={'Amount'} required/>
                            </div>
                            <div className="form-two-input-three">
                                <p className={'form-two-input-three-desc inputs-one-input-one-desc'}>Token</p>
                                <div className={'select-two'}>
                                    <select onChange={onTokenChanged}>
                                        { priceByCurrentPhase && <option value="BUSD">USD</option> }
                                        <option value="PHETA">PHETA</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        {!!phetaAmount && <p className={'select-one-texts-form-two'}>PHETA Amount: <span>{phetaAmount.toLocaleString()}</span></p>}
                        {/*{currentTgeDate == 0 && <p className={'select-one-texts-form-two'} style={ preTgePurchasesLeft < 10 ? {color: 'red', fontSize: '200%'} : {}}>*/}
                        {/*    Pre TGE purchase left: <span>{preTgePurchasesLeft}</span>*/}
                        {/*</p>}*/}
                    </div>
                    { registration ? <a className={'ap-btn'}>Loading...</a> : <a className={'ap-btn'} onClick={register}>register</a> }

                    {/*{ currentTgeDate == 0 &&*/}
                    {/*    <div style={{padding: '50px', borderTop: '2px solid #55FBAC'}}>*/}
                    {/*        <div className={'form-two'}>*/}
                    {/*            <div className="form-two-input-one">*/}
                    {/*                <p className={'form-two-input-one-desc inputs-one-input-one-desc'}>TGE Date</p>*/}
                    {/*                <input onChange={(e) => setNewTgeDate((new Date(e.target.value)).getTime()/1000)}*/}
                    {/*                       type="date" className={'form-two-input-two-input'} placeholder={'TGE Date'} required/>*/}
                    {/*            </div>*/}
                    {/*            { tgeDateUpdating*/}
                    {/*                ? <a className={'ap-btn'} style={{width: 'auto', marginTop: '30px'}}>TGE Date Updating...</a>*/}
                    {/*                : <a className={'ap-btn'} onClick={startVesting} style={{width: 'auto', marginTop: '30px'}}>Set TGE Date</a>*/}
                    {/*            }*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*}*/}
                    { currentTgeDate > 0 &&
                        <div style={{padding: '34px', borderTop: '2px solid #55FBAC'}}>
                            TGE Date: <span>{new Date(currentTgeDate*1000).toLocaleString()}</span>
                        </div>
                    }
                </div>

            </div>
        </section>
    )
}
















